import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { Scale, FileText, Search, Users } from 'lucide-react';
const skillCategories = [{
  title: 'Legal Research',
  icon: <Search className="w-6 h-6 text-amber" data-id="element-92" />,
  skills: ['Westlaw & LexisNexis', 'Case Law Analysis', 'Statutory Research', 'Legal Databases', 'Citation Verification']
}, {
  title: 'Legal Writing',
  icon: <FileText className="w-6 h-6 text-amber" data-id="element-93" />,
  skills: ['Memoranda & Briefs', 'Contract Drafting', 'Pleadings & Motions', 'Case Summaries', 'Client Correspondence']
}, {
  title: 'Practice Areas',
  icon: <Scale className="w-6 h-6 text-amber" data-id="element-94" />,
  skills: ['Civil Litigation', 'Contract Law', 'Corporate Law', 'Legal Ethics', 'Discovery & E-Discovery']
}, {
  title: 'Professional Skills',
  icon: <Users className="w-6 h-6 text-amber" data-id="element-95" />,
  skills: ['Client Communication', 'Case Management', 'Attention to Detail', 'Time Management', 'Team Collaboration']
}];
export function Skills() {
  return <section className="py-24 px-6 bg-cream-dark/40" data-id="element-96">
      <div className="max-w-5xl mx-auto" data-id="element-97">
        <FadeIn className="mb-16" data-id="element-98">
          <div className="flex items-center gap-4" data-id="element-99">
            <div className="h-px w-12 bg-amber/30" data-id="element-100" />
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-101">
              Expertise
            </h2>
            <div className="h-px flex-grow bg-amber/30" data-id="element-102" />
          </div>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-103">
          {skillCategories.map((category, idx) => <StaggerItem key={idx} data-id="element-104">
              <div className="group h-full p-8 bg-cream rounded-2xl border border-amber/10 hover:border-amber/30 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-amber/5" data-id="element-105">
                <div className="mb-6 p-3 bg-cream-dark inline-block rounded-xl group-hover:scale-110 transition-transform duration-500 ease-out" data-id="element-106">
                  {category.icon}
                </div>
                <h3 className="font-playfair text-xl text-charcoal mb-4" data-id="element-107">
                  {category.title}
                </h3>
                <ul className="space-y-3" data-id="element-108">
                  {category.skills.map((skill, sIdx) => <li key={sIdx} className="text-charcoal/70 font-light flex items-center gap-2" data-id="element-109">
                      <span className="w-1 h-1 rounded-full bg-sage/50" data-id="element-110" />
                      {skill}
                    </li>)}
                </ul>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}